import { FC } from 'react';
import NextImage from 'src/shared-components/NextImage/NextImage';

const crossIcon = 'shared/cross.svg';

interface Props {
  onClose(): void;
}

const CloseButton: FC<Props> = ({ onClose }) => {
  return (
    <button
      onClick={onClose}
      className="flex w-4 h-4 rounded-full bg-white p-1"
    >
      <NextImage
        alt="close"
        src={crossIcon}
        layout="fixed"
        height={9}
        width={9}
      />
    </button>
  );
};

export default CloseButton;
